import { Phone, Mail } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Standards", href: "#standards" },
  { label: "Who We Help", href: "#trust" },
  { label: "Trade Partners", href: "#trade-partners" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Footer({ onNav }) {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#2a2a2a] bg-[#050505] pt-20"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo-mark.png" alt="FS Restoration Group" className="h-16 w-auto object-contain" />
              <span className="font-display text-lg font-semibold uppercase tracking-tight text-[#f5f5f0]">
                FS Restoration Group
              </span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#8a8a8a]">
              Swan Hill&apos;s only dedicated restoration and forensic cleaning
              service operating with IICRC certified capability. We deliver
              verified technical certification and standards-based service not
              otherwise available locally, covering planned and unplanned works
              within a 350 km radius across Victoria and NSW.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#8a8a8a]">Navigate</div>
            <div className="mt-5 flex flex-col gap-3">
              {NAV.map((n) => (
                <button
                  key={n.href}
                  onClick={() => onNav(n.href)}
                  className="text-left text-sm text-[#f5f5f0] transition-colors hover:text-[#c4a962]"
                >
                  {n.label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-[#8a8a8a]">Contact</div>
            <div className="mt-5 flex flex-col gap-3">
              <a href="tel:0407051043" className="flex items-center gap-3 text-sm text-[#f5f5f0] transition-colors hover:text-[#c4a962]">
                <Phone className="h-4 w-4 text-[#c4a962]" /> 0407 051 043
              </a>
              <a href="mailto:info@jmvmanagement.com.au" className="flex items-center gap-3 text-sm text-[#f5f5f0] transition-colors hover:text-[#c4a962]">
                <Mail className="h-4 w-4 text-[#c4a962]" /> info@jmvmanagement.com.au
              </a>
              <span className="text-sm text-[#8a8a8a]">Victoria & New South Wales · 24/7 (emergency response)</span>
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              {["S540", "S520", "S500"].map((s) => (
                <span key={s} className="border border-[#2a2a2a] px-3 py-1 text-xs uppercase tracking-wide text-[#c4a962]">
                  IICRC {s}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-3 border-t border-[#2a2a2a] py-8 text-xs text-[#5a5a5a] md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} FS Restoration Group. All rights reserved.</span>
          <span className="md:text-right md:max-w-xl">IICRC Certified Firm &nbsp;|&nbsp; RIA Australasia Member &nbsp;|&nbsp; IAQAA (Australian Chapter) Member &nbsp;|&nbsp; All works aligned with applicable Australian legislation, codes, and standards.</span>
        </div>
      </div>
    </footer>
  );
}
